import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = ({ style = {}, marginTop, height }) => {
  const YEAR = new Date().getFullYear();
  const { pathname } = useLocation();
  const showLegalLinks = pathname !== "/" && pathname !== "/signin" && pathname !== "/signup" && pathname !== "/reset-password" && pathname !== "/set-password";

  return (
    <footer
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        paddingTop: 10,
        justifyContent: 'center',
        alignItems: 'center',
        color: "#494949",
        lineHeight: "1em",
        fontWeight: 400,
        fontSize: 12,
        textAlign: "center",
        padding: "15px 0",
        // borderTop: "1px solid #eee",
        marginTop: "15px",
        height: height ?? "auto",
        ...style,                   
      }}
    >
      © {YEAR} ColdBlock Technologies Inc. All rights reserved.
      
        <div className="d-flex justify-content-center gap-2">
          <a href="https://coldblock.ca/portal-terms-of-use/" target="_blank" rel="noreferrer">Terms of Use</a> | <a href="https://coldblock.ca/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
          {showLegalLinks ? (
            <>
              {" | "}
              <Link to="/support">Support</Link>
            </>
          ) : null}
        </div>
      
    </footer>
  );
};

export default Footer;
